import React, { Component } from "react";
import FadeIn from "react-lazyload-fadein";
import WithConsumer from '../context/WithConsumer';
import { Parallax } from 'react-scroll-parallax';
import { Link } from 'react-router-dom';

export default class ModPageHeader extends Component {
	
	
	
    render () {
	    
	    let block = this.props.block;
	    let images = '';
	    
	    let screenWidth = window.innerWidth;
		let screenHeight = window.innerHeight;
			
	    if (block.portrait_img_srcset) {
		    images = <div className="c-page-header__background">
		    	
		    	{screenWidth > screenHeight &&
			    	<div className="c-page-header__image" style={{opacity : block.image_opacity}}>
					    <FadeIn className="c-page-header__image" duration={250}>
							{onload => (
								<img
									alt={block.img_alt} 
									src={block.img_src} 
									srcSet={block.img_srcset} 
									onLoad={onload}
								/>
							)}
						</FadeIn>
					</div>
				}
				{screenWidth <= screenHeight &&
					<div className="c-page-header__image" style={{opacity : block.image_opacity}}>
						<FadeIn className="c-page-header__image c-page-header__image--portrait" duration={250}>
							{onload => (
								<img
									alt={block.portrait_img_alt} 
									src={block.portrait_img_src} 
									srcSet={block.portrait_img_srcset} 
									onLoad={onload}
								/>
							)}
						</FadeIn>
					</div>
				}
			</div>
	    } else {
		    images = <div className="c-page-header__background">
		    	<div className="c-page-header__image" style={{opacity : block.image_opacity}}>
				    <FadeIn className="c-page-header__image" duration={250}>
						{onload => (
							<img
								alt={block.img_alt} 
								src={block.img_src} 
								srcSet={block.img_srcset} 
								onLoad={onload}
							/>
						)}
					</FadeIn>
				</div>
			</div>
	    }
	    return (
	        <div className={'c-page-header c-page-header--' + block.text_color}>
	        	{block.ph_custom_text_colour &&
		        	<style dangerouslySetInnerHTML={ {__html:'.c-page-header--custom {background-color:' + block.ph_custom_bg_colour + ';}.c-page-header--custom h1, .c-page-header--custom h2, .c-page-header--custom h3, .c-page-header--custom h4, .c-page-header--custom h5, .c-page-header--custom h6, .c-page-header--custom p {color:' + block.ph_custom_text_colour + ';}.c-page-header__text__button {color:' + block.ph_custom_bg_colour + ';background-color:' + block.ph_custom_text_colour + ';}'}}></style>
			        	
	        	}
				{ images }
				<div className={'c-page-header__text-block c-page-header__text-block--placement-' + block.text_placement + ' c-page-header__text-block--alignment-' + block.text_alignment}>
					<div className={'c-page-header__text-block__inner'}>
						{block.heading &&
							<h1 className="c-page-header__text__heading">{ block.heading }</h1>
						}
						<div className="c-page-header__clear"></div>
						{block.subheading &&
							<h3 className="c-page-header__text__subheading">{ block.subheading }</h3>
						}
						<div className="c-page-header__clear"></div>
						{block.button_text && block.button_url && block.button_url.includes('https:') &&
							<a href={{ pathname:block.button_url }} className="c-page-header__text__button" target="_blank">{ block.button_text }</a>
						}
						{block.button_text && block.button_url && block.button_url.includes('http:') &&
							<a href={{ pathname:block.button_url }} className="c-page-header__text__button" target="_blank">{ block.button_text }</a>
						}
						{block.button_text && block.button_url && !block.button_url.includes('https') && !block.button_url.includes('http') &&
							<Link to={{ pathname:block.button_url }} className="c-page-header__text__button">{ block.button_text }</Link>
						}
					</div>
				</div>
			</div>
		)
	};

};
